export interface AfxRenewalPolicy {
  policyNumber: string;
}

export interface AfxRenewalFinalPricing {
  net: number;
  tax: number;
  gross: number;
}

export interface AfxRenewalPaymentProfile {
  gpmProfileId: string;
}

export interface AfxRenewalNewPolicy {
  renewalPolicyNumber: string;
  termStart: string;
  termEnd: string;
}

export interface AfxRenewalSelectedOffer {
  acceptedAt: string;
  billingCadence: string;
  finalPricing: AfxRenewalFinalPricing;
  paymentProfile: AfxRenewalPaymentProfile;
  newPolicy: AfxRenewalNewPolicy;
}

// Named constants for the 3 known AFX renewalStatus values. AfxRenewalResponse.renewalStatus
// stays typed as `string`, not this enum — it's unvalidated external data and AFX may return
// statuses we haven't catalogued yet. Compare with === / Set membership, which safely evaluates
// false for any unrecognized value, instead of narrowing the DTO field itself.
export enum RenewalStatus {
  NotRenewed = 'NOT_RENEWED',
  RenewalOfferAccepted = 'RENEWAL_OFFER_ACCEPTED',
  Renewed = 'RENEWED',
}

export interface AfxRenewalResponse {
  policy: AfxRenewalPolicy;
  renewalStatus: string;
  isOfferAvailable: boolean;
  autoRenewConsent: boolean;
  selectedOffer: AfxRenewalSelectedOffer | null;
}

export interface AfxRenewalConsentUpdateResponse {
  statusCode: number;
  status: string;
  message: string;
}
